import { createClearisticTheme } from './createClearisticTheme';

/**
 * Clearistic dark theme.
 *
 * Colours come from `clearisticPalette`; the shape of the theme comes from
 * `createClearisticTheme`, which builds both modes so they cannot drift apart.
 */
export const clearisticThemeDark = createClearisticTheme('dark');
